import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import Styles from "./css/footerlinks.module.scss";
import FooterlinksSingle from "./footerlinks_single.js";
import siteData from "branding/site-metadata.json";

var ContactUs = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ContactUs, _React$Component);

  function ContactUs(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    if (props.data) {
      _this.state = {
        data: props.data
      };
    }

    return _this;
  }

  var _proto = ContactUs.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", {
      className: Styles.footerlinksContainer
    }, /*#__PURE__*/React.createElement("img", {
      src: siteData.logo,
      className: Styles.siteLogo
    }), /*#__PURE__*/React.createElement("div", null, this.state.data.siteURL, ", the official website of ", this.state.data.siteURL, " extension, is committed to making your user experience pleasant and productive while using this site. Should you have any additional questions, comments, or compliments, you can also reach us via email at ", /*#__PURE__*/React.createElement("a", {
      href: "mailto:" + this.state.data.contactMail,
      target: "_top"
    }, this.state.data.contactMail), " You can also send snail mail to the address below. We welcome your feedback!", /*#__PURE__*/React.createElement("p", {
      style: {
        color: '#2464cf',
        'padding-top': '50px'
      }
    }), /*#__PURE__*/React.createElement("p", null, "Tightrope Interactive, Inc.", /*#__PURE__*/React.createElement("br", null), "248 3rd St. #312", /*#__PURE__*/React.createElement("br", null), "Oakland, CA", /*#__PURE__*/React.createElement("br", null), "94607-4375", /*#__PURE__*/React.createElement("br", null)), "Thanks for your support! -The ", this.state.data.siteURL, " Team", /*#__PURE__*/React.createElement(FooterlinksSingle, null))));
  };

  return ContactUs;
}(React.Component);

export default ContactUs;